import { z } from 'zod';

import {
  EMAIL_REGEX,
  INCORRECT_FORMAT_MESSAGE,
  MONEY_REGEX,
  OWNS_HOME_ERROR_MESSAGE,
  PHONE_REGEX,
  REQUIRED_FIELD_MESSAGE,
  ZIP_REGEX,
} from './constants';

export enum InputName {
  FIRST_NAME = 'firstName',
  LAST_NAME = 'lastName',
  FULL_NAME = 'fullName',
  EMAIL = 'email',
  ZIP_CODE = 'zipCode',
  PHONE = 'phone',
  OWN_HOME = 'ownHome',
  LAST_BILL = 'lastBill',
  UTILITY = 'utility',
  REFERRED = 'referred',
  ADDRESS = 'address',
}

// TODO: PXE-2436, move this to a better place
export enum OwnHome {
  OWN = 'OWN',
  RENT = 'RENT',
}

export const nonEmptyStringValidator = z
  .string()
  .nonempty(REQUIRED_FIELD_MESSAGE);
export const firstNameValidator = {
  [InputName.FIRST_NAME]: nonEmptyStringValidator,
};
export const lastNameValidator = {
  [InputName.LAST_NAME]: nonEmptyStringValidator,
};
export const fullNameValidator = {
  [InputName.FULL_NAME]: nonEmptyStringValidator,
};
export const billAmountsValidator = {
  [InputName.LAST_BILL]: nonEmptyStringValidator,
};

export const emailValidator = {
  [InputName.EMAIL]: nonEmptyStringValidator.regex(
    EMAIL_REGEX,
    INCORRECT_FORMAT_MESSAGE('email address')
  ),
};
export const zipCodeValidator = {
  [InputName.ZIP_CODE]: nonEmptyStringValidator.regex(
    ZIP_REGEX,
    INCORRECT_FORMAT_MESSAGE('zip code')
  ),
};

export const utilDropdownValidator = {
  [InputName.UTILITY]: nonEmptyStringValidator,
};
export const phoneValidator = {
  [InputName.PHONE]: nonEmptyStringValidator.regex(
    PHONE_REGEX,
    INCORRECT_FORMAT_MESSAGE('phone number')
  ),
};

export const referredValidator = {
  [InputName.REFERRED]: z.boolean({ message: REQUIRED_FIELD_MESSAGE }),
};
export const ownHomeValidator = {
  [InputName.OWN_HOME]: z.enum(OwnHome, {
    error: REQUIRED_FIELD_MESSAGE,
  }),
};

export const ownHomeRadioValidator = {
  [InputName.OWN_HOME]: ownHomeValidator[InputName.OWN_HOME].refine(
    (val) => val === OwnHome.OWN,
    {
      message: OWNS_HOME_ERROR_MESSAGE,
    }
  ),
};

export const booleanIsTrueValidator = {
  [InputName.OWN_HOME]: z.literal(true, {
    message: OWNS_HOME_ERROR_MESSAGE,
  }),
};

export const lastBillValidator = {
  [InputName.LAST_BILL]: nonEmptyStringValidator
    .regex(MONEY_REGEX, INCORRECT_FORMAT_MESSAGE('bill amount'))
    .refine(
      // biome-ignore lint/correctness/useParseIntRadix: Automated migration to Biome
      (val) => parseInt(val) >= 1,
      INCORRECT_FORMAT_MESSAGE('bill amount')
    ),
};

export const honeypotAddressFieldValidator = {
  [InputName.ADDRESS]: z.string().optional(),
};
